
import { Icon, Tag } from "@blueprintjs/core"
import { __ } from "src/libs/utilities"
import { ILandingSection, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import useSelectedContent from "src/modules/pe-landing-module/hooks/useSelectedContent"

/* Protopia Ecosystem component */
export interface ISingleTransformPanel {
   
}
const SingleTransformPanel = (props: ISingleTransformPanel): JSX.Element => {
     const selectedData                     = useSelectedContent()
    const { currentLanding, selectedLayer }	= useLandingStore((state: ILandingStore) => state)
    const section: ILandingSection          = currentLanding.sections.find((section: ILandingSection) => section.id === selectedLayer)
     
    return selectedData.type !== SELECT_TYPE.NONE
        ?
        <div className='landing-select-layer-panel'>
            <div className="d-flex pt-1 pl-1 pb-1 small w-100"> 
                <Tag 
                    minimal 
                    size="medium" 
                    className="small text-light py-0 px-1 mr-1 hover pointer"
                    onClick={() => {} } 
                    style={{height: 22}}
                >  
                    <div className="d-flex align-items-center ">
                        <Icon icon="cross" size={ 9 } /> 
                        <div className="ml-2 micro letter-spacing-2">
                            {__("Reset transform")}
                        </div>
                    </div>
                </Tag>      
            </div>
        </div>
        : 
        <></>
}
export default SingleTransformPanel
/// export default 